import React from "react";
import PropTypes from "prop-types";
import { Menu } from "../MenuList/Menu";
import { DesignSectionMenu } from "../DesignSectionMenu";
import { Utilities } from "@learningblocks/exp-constants";
const { NOTEBOOK } = Utilities;

/**
 * MobileChapterMenu
 *  - Single ChapterMenu to be displayed on view ['MOB', 'TAB']
 */
export function MobileChapterMenu(props) {
  if (props.value === NOTEBOOK.SECTION.DESIGN && props.current) {
    return (
      <DesignSectionMenu
        onSelect={props.onSelect}
        title={props.title}
        number={props.number}
        tabIndex={props.tabIndex}
        className={props.className}
      />
    );
  } else {
    return (
      <Menu
        onSelect={props.onSelect}
        title={props.title}
        current={props.current}
        number={props.number}
        visited={props.visited}
        tabIndex={props.tabIndex}
        className={props.className}
      />
    );
  }
}

MobileChapterMenu.propTypes = {
  /**
   * Callback fired when a Menu is Selected/Clicked
   */
  onSelect: PropTypes.func,
  /**
   * Title to display in  menu
   */
  title: PropTypes.string.isRequired,
  /**
   * Boolean specifying if menu is selected
   */
  current: PropTypes.bool.isRequired,
  /**
   * Index number of menu
   */
  number: PropTypes.number.isRequired,
  /**
   * Unique string value of the menu
   */
  value: PropTypes.string.isRequired,
  /**
   * Boolean set when section is visited
   */
  visited: PropTypes.bool.isRequired,
  /**
   * TabIndex to set on Menu
   */
  tabIndex: PropTypes.number,
  /**
   * ClassName
   */
  className: PropTypes.string,
};

MobileChapterMenu.defaultProps = {
  className: "",
};
